import auth from './auth.json';
import chat from './chat.json';
import navMenu from './navMenu.json';
import resources from './resources.json';
import statHeader from './statHeader.json';
import explore from './explore.json';
import loadingModal from './loadingModal.json';
import announcement from './announcement.json';
import voiceMode from './voiceMode.json';
import migration from './migration.json';

const en = {
  auth,
  chat,
  navMenu,
  resources,
  statHeader,
  explore,
  loadingModal,
  announcement,
  voiceMode,
  migration,
};

export const namespaces = Object.keys(en);
export const defaultNS = 'base';

export default en;
